import React from 'react';

export const Problem = () => {
  const problems = [
    {
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      ),
      text: 'Events show what happened, not what users were trying to do',
    },
    {
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
        </svg>
      ),
      text: "Raw chat logs don't scale past a handful of conversations",
    },
    {
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
        </svg>
      ),
      text: 'Funnels disappear when every path is different',
    },
  ];

  return (
    <section className="py-32 md:py-40 bg-neutral-950 relative overflow-hidden">
      {/* Ambient lighting effects */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-turret-purple/10 rounded-full blur-[150px]" />
        <div className="absolute bottom-0 right-1/4 w-[400px] h-[400px] bg-indigo-500/10 rounded-full blur-[120px]" />
      </div>

      {/* Subtle grid */}
      <div 
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}
      />

      <div className="section-container relative z-10">
        <div className="max-w-4xl mx-auto">
          <p className="text-turret-purple font-semibold tracking-wide uppercase text-sm mb-6">
            The Challenge
          </p>
          
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-16 leading-[1.1] tracking-tight">
            Traditional analytics breaks down the moment users start typing.
          </h2>

          <div className="space-y-4 mb-16">
            {problems.map((problem, index) => (
              <div
                key={index}
                className="group flex items-center gap-5 p-6 rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm hover:bg-white/10 hover:border-white/20 transition-all duration-300"
              >
                <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center text-neutral-400 group-hover:text-turret-purple group-hover:bg-turret-purple/20 transition-all duration-300">
                  {problem.icon}
                </div>
                <p className="text-lg text-neutral-300 leading-relaxed">
                  {problem.text}
                </p>
              </div>
            ))}
          </div>

          {/* Callout */}
          <div className="relative">
            <div className="absolute -inset-1 bg-gradient-to-r from-turret-purple via-indigo-500 to-turret-purple-light rounded-3xl blur-lg opacity-50" />
            <div className="relative p-8 md:p-10 rounded-2xl bg-neutral-900 border border-white/10">
              <p className="text-2xl md:text-3xl font-semibold text-white leading-snug">
                AI product teams are missing{' '}
                <span className="relative inline-block">
                  <span className="relative z-10 text-purple-300">critical</span>
                  <span className="absolute bottom-1 left-0 w-full h-3 bg-turret-purple/20 -skew-x-6" />
                </span>
                {' '}data inside language.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
